import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppRouter from "./AppRouter";
import RouteTracker from "./pages/RouteTracker";

const GlobalShortcuts = () => {

  const navigate = useNavigate();

  useEffect(() => {

    const handleKey = (e) => {

      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA"
      ) return;

      if ((e.ctrlKey || e.metaKey) && e.shiftKey) {

        let path = "";

        switch (e.key.toLowerCase()) {

          case "s": path = "/sales"; break;
          case "i": path = "/payment-in"; break;
          case "o": path = "/payment-out"; break;
          case "p": path = "/purchase"; break;
          case "r": path = "/purchasereturn"; break;
          case "t": path = "/salereturn"; break;
          case "e": path = "/expense"; break;
          default: return;
        }

        navigate(path);
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);

  }, [navigate]);

  return null;
};

function App() {

  const navigate = useNavigate();

  /* ✅ RESTORE LAST PAGE (ONLY ON FIRST LOAD) */
  useEffect(() => {
    const savedPage = localStorage.getItem("activePage");

    if (savedPage && savedPage !== window.location.pathname) {
      navigate(savedPage);
    }
  }, []);

  return (
    <>
      <RouteTracker /> {/* ✅ VERY IMPORTANT */}
      <GlobalShortcuts />
      <AppRouter />
    </>
  );
}

export default App;